import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useMemo } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';

import { ThemeProvider } from './theme-provider.jsx';

import { env } from '@/config/env.js';
import { createQueryClient } from '@/lib/query-client.js';


if (env.SENTRY_DSN) {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    environment: env.ENVIRONMENT,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  });
}

export function AppProvider({ children }) {
  const queryClient = useMemo(() => createQueryClient(), []);
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          {children}
          <Toaster richColors position="bottom-right" />
        </ThemeProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}
